import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const OurValuesSliderBuilder = ({slider1Slides}) => {
  

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {slider1Slides.map((block, i) => (
        <div key={i}>
          <div className='value-slide-bx'>
            <h2 className='heading-level-3-i white-color text-uppercase'>
              {block.slider1SlideTitle}
            </h2>
            <p>{block.slider1SlideText}</p>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default OurValuesSliderBuilder;
